import React, { useState, useEffect } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { DataElement } from "@/entities/all";

export default function ElementEditModal({ isOpen, onClose, element, onElementUpdated }) {
  const [formData, setFormData] = useState({
    canonical_name: '',
    is_public: false
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (element) {
      setFormData({
        canonical_name: element.canonical_name || '',
        is_public: element.is_public || false
      });
    }
  }, [element, isOpen]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!element) return;
    
    setIsSubmitting(true);
    try {
      await DataElement.update(element.id, formData);
      onElementUpdated();
    } catch (error) {
      console.error('Error updating element:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-lg">
        <DialogHeader>
          <DialogTitle>Edit Data Element</DialogTitle>
          <DialogDescription>
            Modify the core properties of '{element?.canonical_name}'. These changes affect all versions.
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={handleSubmit} className="space-y-6 mt-4">
          <div>
            <Label htmlFor="canonical_name">Canonical Name</Label>
            <Input
              id="canonical_name"
              value={formData.canonical_name}
              onChange={(e) => handleChange('canonical_name', e.target.value)}

              required
            />
          </div>

          <div className="flex items-center justify-between rounded-lg border p-4">
              <div className="space-y-0.5">
                <Label htmlFor="is_public">Is Public</Label>
                <p className="text-[0.8rem] text-muted-foreground">
                  Make this element visible in external portals.
                </p>
              </div>
              <Switch
                id="is_public"
                checked={formData.is_public}
                onCheckedChange={(checked) => handleChange('is_public', checked)}
              />
          </div>


          <div className="flex justify-end gap-3 pt-4 border-t">
            <Button type="button" variant="outline" onClick={onClose}>
              Cancel
            </Button>
            <Button type="submit" disabled={isSubmitting}>
              {isSubmitting ? 'Updating...' : 'Update Element'}
            </Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
}
